import { func } from "prop-types";

import styled from "styled-components";

import { usePermissions } from "Flocknote/apiHooks";

import { menuTypographyProps } from "NavBar/components/NavLink";
import SettingsOptionWrapper from "NavBar/components/settings/SettingsOptionWrapper";
import SettingsOptionsWrapper from "NavBar/components/settings/SettingsOptionsWrapper";
import { useIsContactSettingsButtonFlashing } from "NavBar/stateHooks";
import { menuIconProps } from "NavBar/styleConstants";

import FnrShineButton from "UI/FnrButton3/FnrShineButton";
import FnrContainedIcon from "UI/FnrContainedIcon";
import FnrTypography from "UI/FnrTypography";
import { marketingColors } from "UI/colors";

import { addOpacity } from "Utilities/Colors/colorUtils";
import flash from "Utilities/interpolations/flash";

import AppendLink from "../AppendLink";

const PopperContent = ({ setCloseTrigger }) => {
  const [
    {
      canSeeNetworkSettingsNav,
      canSeeNetworkSecurityNav,
      canSeeBillingNav,
      canViewContactSettings,
      canViewSocialAndSharing,
    },
  ] = usePermissions();
  const isContactSettingsButtonFlashing = useIsContactSettingsButtonFlashing();

  return (
    <SettingsOptionsWrapper>
      {canSeeNetworkSettingsNav && (
        <AppendLink
          to="/settings/network"
          data-cy="NavBar_NetworkSettingsButton"
          onClick={() => {
            setCloseTrigger({});
          }}
        >
          <SettingsOptionWrapper>
            <FnrContainedIcon icon="church fas" {...menuIconProps} />
            <FnrTypography {...menuTypographyProps}>
              Network Settings
            </FnrTypography>
          </SettingsOptionWrapper>
        </AppendLink>
      )}
      {canViewContactSettings && (
        <SFlashingAppendLink
          to="/settings/network-welcome"
          data-cy="NavBar_ContactSettingsButton"
          $isFlashing={isContactSettingsButtonFlashing}
          $flashToColor={addOpacity(marketingColors.lightBlue, 0.2)}
          onClick={() => {
            setCloseTrigger({});
          }}
        >
          <SettingsOptionWrapper>
            <FnrContainedIcon icon="comments-alt fas" {...menuIconProps} />
            <FnrTypography {...menuTypographyProps}>
              Contact Settings
            </FnrTypography>
          </SettingsOptionWrapper>
        </SFlashingAppendLink>
      )}
      {canViewSocialAndSharing && (
        <AppendLink
          to="/settings/network-sharing"
          data-cy="NavBar_SocialAndSharingButton"
          onClick={() => {
            setCloseTrigger({});
          }}
        >
          <SettingsOptionWrapper>
            <FnrContainedIcon icon="share fas" {...menuIconProps} />
            <FnrTypography {...menuTypographyProps}>
              Social & Sharing
            </FnrTypography>
          </SettingsOptionWrapper>
        </AppendLink>
      )}
      {canSeeNetworkSecurityNav && (
        <AppendLink
          to="/settings/network-security"
          data-cy="NavBar_SecuritySettingsButton"
          onClick={() => {
            setCloseTrigger({});
          }}
        >
          <SettingsOptionWrapper>
            <FnrContainedIcon icon="lock fas" {...menuIconProps} />
            <FnrTypography {...menuTypographyProps}>
              Network Security
            </FnrTypography>
          </SettingsOptionWrapper>
        </AppendLink>
      )}
      {canSeeBillingNav && (
        <FnrShineButton
          borderRadius={8}
          onClick={() => {
            window.handleNavigateToBillingSettings();
            setCloseTrigger({});
          }}
          data-cy="NavBar_BillingSettingsButton"
        >
          <SettingsOptionWrapper>
            <FnrContainedIcon
              icon="file-invoice-dollar fas"
              {...menuIconProps}
            />
            <FnrTypography {...menuTypographyProps}>
              Billing Information
            </FnrTypography>
          </SettingsOptionWrapper>
        </FnrShineButton>
      )}
    </SettingsOptionsWrapper>
  );
};

PopperContent.propTypes = { setCloseTrigger: func };

const SFlashingAppendLink = styled(AppendLink)`
  ${flash}
`;

export default PopperContent;
